import {handleActions, createAction} from 'redux-actions';

import {
    axios,
    axiosWithoutHeaders
} from "../cores/axiosWrapper";

import PhotoApi from './apis/photo';

//action type
const PHOTO_CREATE_RESET = 'PHOTO_CREATE_RESET'
const PHOTO_CREATE_SUCCESS = 'PHOTO_CREATE_SUCCESS';
const PHOTO_CREATE_FAILURE = 'PHOTO_CREATE_FAILURE';

const initialState = {
    pending : false,
    error : false,
}

export default handleActions({
    [PHOTO_CREATE_RESET] : (state, action) => {
        return { 
            ...initialState, 
        }; 
    },

    [PHOTO_CREATE_SUCCESS] : (state, action) => {
        const { data } = action.payload;

        console.log("PHOTO_CREATE_SUCCESS data:", data);
        
        // const temp = {
        //     ...tempState,
        //     data: data,
        //     contextVersion: tempState.contextVersion + 1
        // };

        // tempState = temp;

        // return tempState;
    },

    [PHOTO_CREATE_FAILURE] : (state, action) => {
        const { data } = action.payload;

        console.log("PHOTO_CREATE_FAILURE data:", data);
        
        // const temp = {
        //     ...tempState,
        //     data: data,
        //     contextVersion: tempState.contextVersion + 1
        // };

        // tempState = temp;

        // return tempState;
        return {
            pending : false,
            error : true,
        }
    }

}, initialState);

export const reset = createAction(PHOTO_CREATE_RESET);
export const createPhotoAsync = (data) => (dispatch, getState) =>{
    const {
        stage,
        project        
    } = getState();

    return PhotoApi.createPhotoAsync(stage.id, stage.endpoint, project.id, data)
        .then((response) => {
            dispatch({
                type: PHOTO_CREATE_SUCCESS,
                payload: response
            });
        })
        .catch((error) => {
            console.log("errir :", error);
            dispatch({
                type: PHOTO_CREATE_FAILURE,
                payload: error
            }); 
        });
}
